import { render } from "./DescriptionSourcesPanel.vue?vue&type=template&id=6c36c268&ts=true"
import script from "./DescriptionSourcesPanel.vue?vue&type=script&lang=ts"
export * from "./DescriptionSourcesPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__